import { AxiosInstance } from 'axios';
import { logger } from '../../../utils/logger';

export const setupErrorInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401) {
        localStorage.removeItem('auth_token');
        window.location.href = '/';
      }
      logger.error('API Response Error:', error);
      return Promise.reject(error);
    }
  );
};
